export default "__VITE_ASSET__BGxaKsZ2__"